module.exports = __webpack_public_path__ + "img/矢量智能对象(3).90245b8b.png";